import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 9v-3.586a1 1 0 0 1 1.707 -.707l6.586 6.586a1 1 0 0 1 0 1.414l-6.586 6.586a1 1 0 0 1 -1.707 -.707v-3.586h-6v-6h6","key":"svg-0"}],["path",{"d":"M3 9v6","key":"svg-1"}]]

const IconArrowBigRightLine = createReactComponent('outline', 'arrow-big-right-line', 'ArrowBigRightLine', __iconNode);

export default IconArrowBigRightLine;